<div class="tw-w-full tw-flex tw-flex-row tw-items-center tw-gap-3 tw-flex-wrap md:tw-flex-nowrap">
    <h2 class="tw-text-base tw-font-medium tw-whitespace-nowrap">{{ title | translate }}</h2>

    <div class="tw-flex-1 tw-min-w-[120px]">
        <div class="tw-w-full tw-h-[13px] tw-flex tw-rounded-full tw-overflow-hidden" *ngIf="!empty" [mhTooltip]="'followup.summary.data-rate.semantic_indicator.tooltip' | translate: {positivePercentage: positivePercentage | formatPercent:true:false:true, negativePercentage: negativePercentage | formatPercent:true:false:true} " >
            <div class="tw-bg-[#FF3B30] tw-h-full" [style.width.%]="negativePercentage"></div>
            <div class="tw-bg-[#34C759] tw-h-full" [style.width.%]="positivePercentage"></div>
        </div>
        <div class="tw-w-full tw-h-6 tw-flex tw-rounded-full tw-overflow-hidden tw-bg-gray-300" *ngIf="empty"></div>
    </div>


    <span class="tw-text-base tw-font-medium tw-text-gray-800 tw-whitespace-nowrap">{{ positivePercentage |
        formatPercent:true:false:true }}</span>
    <button *ngIf="!hideActionButton" class="tw-text-main tw-font-['Rubik'] tw-text-sm tw-font-semibold tw-text-end" (click)="handleActionClick()">{{ actionText | translate | uppercase }}</button>
</div>